import { createEntityAdapter, EntityState } from "@magicware/redux/entities";
import { anchoreThunks, AsyncSliceState } from "@magicware/redux/thunks";
import { createSlice } from "@reduxjs/toolkit";
import {
    entityApi,
    ConnectorImplementationModelDetail,
    ConnectorImplementationFilter,
    ConnectorImplementationModelList,
} from "../../services/api/connectorImplementations";
import { RootState } from "../types";

export interface State
    extends EntityState<
            ConnectorImplementationModelDetail,
            ConnectorImplementationModelList,
            ConnectorImplementationFilter
        >,
        AsyncSliceState {}

const initialState: State = { async: {} };

const adapter = createEntityAdapter("connectorImplementations", entityApi, []);

const extraThunks = {};

const slice = createSlice({
    name: "connectorImplementations",
    initialState,
    reducers: adapter.getReducers(),
    extraReducers: (builder) => {
        adapter.addExtraReducers(builder);
        //addAsyncThunkReducers(builder, extraThunks.xxx);
    },
});

export const connectorImplementationThunks = anchoreThunks((state: RootState) => state.connectorImplementations, {
    ...extraThunks,
    ...adapter.thunks,
});

export const actions = slice.actions;
export const { updateDetail, clearList, removeListItems, updateListItems, setPage } = slice.actions;
export default slice.reducer;
